<template>
  <div>
    <Home/>
  </div>
</template>

<script>
import Home from '@/pages/Home.vue'

export default {
  name: 'App',
  components: {
    Home,
  },
  /*
  mixins: [i18n],
  props: {
    locale: {
      type: String,
      default: null
    }
  },
  beforeMount () {
    this.setLocale(this.$route.params.locale)
  },
  beforeRouteUpdate (to, from, next) {
    this.setLocale(to.params.locale)
    next()
  }
*/    
}
</script>

<style lang="scss">

  @keyframes slideDownArrow {
    from {
      opacity: 0;
      bottom: 100px;
    }

    to {
      opacity: 1;
      bottom: -100px;
    }
  }

  .container-arrow-down {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 5px 0px 0 0;
    z-index: 9999;
    text-align: center;
    background: linear-gradient(rgba(255, 255, 255, 0), #ffffff43);

    .icon-down {
      position: relative;
      display: inline-block;
      width: 100%;
      max-width: 360px;
      margin: 0 auto;
      text-align: center;
      animation: slideDownArrow 2.7s infinite ease-in-out;
      transition: transform 1.5s ease-in-out;

      svg {
        fill: #FA6632;
        color: #FA6632;
        width: 64px;
        height: 64px;
      }
    }
  }
</style>


